<header>
<div class="row">
	<div class="istitutional-bar col container-fluid">
	<!-- <div class="istitutional-bar col col-sm-9 container-fluid"> -->
		<div class="header-flex ml-3">
			<div *ngIf="this.commonService?.pages?.logoRegioneHeader" class="logo-title">
			<!-- <div *ngIf="this.commonService?.pages?.logoRegioneHeader" class="col-md-3 px-3 logo-title"> -->
				<!-- <div *ngIf="(isLoggedIn$ | async)" id="menu-icon" (click)="toggleMenu()"
					[ngClass]="{'open': (isMenuOpen$ | async)}">
					<span></span>
					<span></span>
					<span></span>
					<span></span>
				</div> -->
				<img class="logo" [src]="this.commonService?.pages?.logoRegioneHeader ? this.commonService?.pages?.logoRegioneHeader : ''" alt="Logo regione" />
			</div>
			<div class="">
			<!-- <div class="col-md ml-3" [ngClass]="getClass()"> -->
				<span [attr.aria-label]="this.commonService?.pages?.titolo_header" class="header-title">{{ this.commonService?.pages?.titolo_header}}</span>
			</div>
		</div>
		
	</div>
		<div *ngIf="this.commonService?.pages?.logo_header_destra" class="col-2 text-center">
			<img style="max-height: 50px; max-width: 160px;"  class="logo" [src]="this.commonService?.pages?.logo_header_destra ? this.commonService?.pages?.logo_header_destra : ''" alt="Logo secondario" />
		</div>
</div>

</header>
<app-mobile-menu ></app-mobile-menu>